export function generateDynamicColorSchemeCSS(scheme: { [tint: string]: string }): string {
  console.log({ scheme });
  const variables = Object.entries(scheme).map(([tint, hex]) => {
    return generateColorVariable(tint, hex);
  });
  return `:root {${variables.join(" ")}}`;
}

function generateColorVariable(tint: string, definition: string) {
  let r, g, b;
  if (definition.startsWith("oklch(")) {
    [r, g, b] = oklchToRGB(definition);
  } else {
    [r, g, b] = hexToRGB(definition);
  }

  return `${variableName(tint)}: ${r} ${g} ${b};`;
}
function oklchToRGB(definition: string): [number, number, number] {
  // Parse oklch(L C H) — also handles oklch(L C H / A)
  console.log("calucating in oklch()", definition);
  const match = definition.match(/oklch\(\s*([\d.]+)(%?)\s+([\d.]+)\s+([\d.]+)/);
  if (!match) throw new Error(`Invalid oklch value: ${definition}`);

  const L = parseFloat(match[1]) / (match[2] === "%" ? 100 : 1);
  const C = parseFloat(match[3]);
  const H = parseFloat(match[4]);

  // 1. OKLCh → OKLab
  const hRad = (H * Math.PI) / 180;
  const a = C * Math.cos(hRad);
  const b = C * Math.sin(hRad);

  // 2. OKLab → linear sRGB (via the OKLab matrix)
  const l_ = L + 0.3963377774 * a + 0.2158037573 * b;
  const m_ = L - 0.1055613458 * a - 0.0638541728 * b;
  const s_ = L - 0.0894841775 * a - 1.291485548 * b;

  const l = l_ ** 3;
  const m = m_ ** 3;
  const s = s_ ** 3;

  const linR = 4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s;
  const linG = -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s;
  const linB = -0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s;

  // 3. Linear sRGB → gamma-corrected sRGB → clamp → [0, 255]
  const toSRGB = (c: number): number => {
    const gamma = c <= 0.0031308 ? 12.92 * c : 1.055 * c ** (1 / 2.4) - 0.055;
    return Math.round(Math.min(1, Math.max(0, gamma)) * 255);
  };

  console.log([toSRGB(linR), toSRGB(linG), toSRGB(linB)]);
  return [toSRGB(linR), toSRGB(linG), toSRGB(linB)];
}
function hexToRGB(definition: string): [number, number, number] {
  const color = definition.replace(/#/g, "");
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);
  return [r, g, b];
}
function variableName(tint: string): string {
  return `--seed-color-${tint}`;
}
